/**
 * Application configuration constants
 * Centralized location for all magic numbers and configurable values
 */

// Auto-save configuration
export const AUTO_SAVE_DEBOUNCE_MS = 15000; // Increased from 2500 to reduce autosave frequency
export const AUTO_SAVE_IDLE_TIMEOUT_MS = 3000;

// History/Undo configuration
export const HISTORY_LIMIT = 50;

// AI Assistant configuration
export const ASSISTANT_MAX_TOKENS = 4000;
export const ASSISTANT_RATE_LIMIT = 20; // requests per minute

// Graph/Node configuration
export const DEFAULT_NODE_POSITION = { x: 50, y: 50 };
export const MAX_COMPONENT_LINES = 300; // Target max lines per component
export const MAX_NODE_NAME_LENGTH = 100;

// Performance configuration
export const LARGE_GRAPH_NODE_THRESHOLD = 100;
export const MAX_ERROR_LOGS = 100;

// Simulation configuration
export const DEFAULT_TRIAL_COUNT = 10000;
export const MAX_TRIAL_COUNT = 10000;
export const MIN_TRIAL_COUNT = 10000;

// UI configuration
export const ERROR_NOTIFICATION_DURATION_MS = 5000;
export const LOADING_DEBOUNCE_MS = 300;

// Layout configuration
export const TIDY_LAYOUT_PADDING = 0.2;
export const MINIMAP_NODE_STROKE_COLOR_LIGHT = '#94a3b8';
export const MINIMAP_NODE_STROKE_COLOR_DARK = '#1f2737';

// API configuration
export const API_REQUEST_TIMEOUT_MS = 30000;
export const API_RETRY_COUNT = 3;
export const API_RETRY_DELAY_MS = 1000;

// Subscription configuration
export const FREE_TIER_ASSISTANT_REQUESTS_LIMIT = 20;
export const FREE_TIER_SIMULATION_LIMIT = 1;
